import * as React from 'react';
import Modal from 'react-modal';

import ListBatchActions from 'components/ListSidebar/ListBatchActions';
// @ts-ignore
import { PeopleListRow } from 'components/PeopleList/PeopleListTableDataContainer';
// @ts-ignore
import RequestTranscriptModal from 'organizations/components/RequestTranscriptModal';
// @ts-ignore
import RemoveFromOrgModal from 'organizations/components/RemoveFromOrgModal';
// @ts-ignore
import { BatchRoleCorrectionModalDataContainer } from 'users/components/BatchRoleCorrectionModal';
import EventTracking from 'lib/EventTracking';
// @ts-ignore
import { OrgInfo } from 'components/PeopleList/PeopleList';

export type Props = {
  rows: PeopleListRow[];
  onDeselectAll: () => void;
  associatedOrg: OrgInfo;
  reloadList: () => void;
};

type State = {
  roleSelectModalOpen: boolean;
  messageHistoriesModalOpen: boolean;
  removeModalOpen: boolean;
  usersModified: boolean;
};

export default class OrgPeopleListBatchActions extends React.Component<Props, State> {
  state: State = {
    roleSelectModalOpen: false,
    messageHistoriesModalOpen: false,
    removeModalOpen: false,
    usersModified: false,
  };

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  mounted: boolean = false;

  trackEvent = (key: string) => {
    const { associatedOrg } = this.props;

    EventTracking.trackKey(key, {
      organization_uuid: associatedOrg.uuid,
    });
  };

  afterRemovedUsers = () => {
    const { reloadList, onDeselectAll } = this.props;

    this.trackEvent('school_people_list.batch.users.removed');

    reloadList();
    onDeselectAll();
  };

  afterRoleChange = () => {
    this.trackEvent('school_people_list.batch.roles.changed');
    this.setState({ usersModified: true });
  };

  afterGetMessageHistories = () => {
    this.trackEvent('school_people_list.batch.transcripts.requested');
  };

  openChangeRoleModal = () => {
    this.setState({
      roleSelectModalOpen: true,
    });
  };

  closeChangeRoleModal = () => {
    const { reloadList } = this.props;
    const { usersModified } = this.state;

    if (this.mounted) {
      this.setState({
        roleSelectModalOpen: false,
      });

      if (usersModified) {
        reloadList();
        this.setState({ usersModified: false });
      }
    }
  };

  openGetMessageHistoriesModal = () => {
    this.setState({
      messageHistoriesModalOpen: true,
    });
  };

  closeGetMessageHistoriesModal = () => {
    if (this.mounted) {
      this.setState({
        messageHistoriesModalOpen: false,
      });
    }
  };

  openRemoveUsersModal = () => {
    this.setState({
      removeModalOpen: true,
    });
  };

  closeRemoveUsersModal = () => {
    if (this.mounted) {
      this.setState({
        removeModalOpen: false,
      });
    }
  };

  renderMessageHistoriesModal(onRequestHide: () => void) {
    const { associatedOrg, rows } = this.props;

    const formattedUsers = rows.map(u => {
      const { user, userInteractionPermissions } = u;
      const { id, firstName, lastName } = user;
      const { canGetMessageHistory, canRequestMessageHistory } = userInteractionPermissions;

      return {
        id,
        fullName: `${firstName || ''} ${lastName || ''}`,
        firstName: firstName || '',
        canGetMessageHistory,
        canRequestMessageHistory,
      };
    });

    return (
      <RequestTranscriptModal
        onRequestHide={onRequestHide}
        onGetTranscript={this.afterGetMessageHistories}
        users={formattedUsers}
        organizationId={associatedOrg.id}
      />
    );
  }

  renderRemoveFromOrgModal = (onRequestHide: () => void) => {
    const { rows, associatedOrg } = this.props;
    const userIds = rows.map(u => u.user.id);

    return (
      <RemoveFromOrgModal
        onRequestHide={onRequestHide}
        isAdminView
        userIds={userIds}
        orgId={associatedOrg.id}
        onRemoved={this.afterRemovedUsers}
        orgName={associatedOrg.name}
      />
    );
  };

  renderRoleCorrectionModel = (onRequestHide: () => void) => {
    const { rows, associatedOrg } = this.props;

    return (
      <BatchRoleCorrectionModalDataContainer
        onRequestHide={onRequestHide}
        organization={associatedOrg}
        users={rows.map(row => row.user)}
        onUserRoleSave={this.afterRoleChange}
      />
    );
  };

  actionDisabled = (rows: PeopleListRow[], permissionKey: string) => {
    return rows.some(r => !r.userInteractionPermissions[permissionKey]);
  };

  render() {
    const { onDeselectAll, rows } = this.props;
    const { roleSelectModalOpen, messageHistoriesModalOpen, removeModalOpen } = this.state;
    const tooltipContent =
      'Unavailable because one or more of the people in the selection are Remind administrators';

    const actions = [
      {
        title: 'Change role',
        onClick: this.openChangeRoleModal,
        disabled: this.actionDisabled(rows, 'canChangeRole'),
        subtext: 'Apply new roles to selected users.',
        tooltip: tooltipContent,
      },
      {
        title: 'Get message histories',
        onClick: this.openGetMessageHistoriesModal,
        disabled: this.actionDisabled(rows, 'canRequestMessageHistory'),
        subtext: 'Get the complete message histories of the selected users.',
        tooltip: tooltipContent,
      },
      {
        title: 'Remove',
        onClick: this.openRemoveUsersModal,
        disabled: this.actionDisabled(rows, 'canRemoveFromGroup'),
        subtext: 'Remove these users from the organization.',
        tooltip: tooltipContent,
      },
    ];

    return (
      <ListBatchActions actions={actions} onDeselectAll={onDeselectAll} rows={rows}>
        <Modal isOpen={roleSelectModalOpen}>
          {this.renderRoleCorrectionModel(this.closeChangeRoleModal)}
        </Modal>
        <Modal isOpen={messageHistoriesModalOpen}>
          {this.renderMessageHistoriesModal(this.closeGetMessageHistoriesModal)}
        </Modal>
        <Modal isOpen={removeModalOpen}>
          {this.renderRemoveFromOrgModal(this.closeRemoveUsersModal)}
        </Modal>
      </ListBatchActions>
    );
  }
}
